module.exports = __webpack_public_path__ + "img/arrow-prev-next.fee9a6ac.svg";